import { use, useEffect } from 'react';
import { LocalStorageKey } from '../data/client_local_storage.ts';
import { useLocalStorage } from '../data/use_local_storage.tsx';
import { holdScreenWakeLock } from '../util/screen_wake_lock.ts';
import { SequencerContext } from './sequencer.tsx';

// Holds the screen awake while the full player is up with a song in it and the "Keep Screen Awake"
// song option is on (issue #3608). The full player on screen is the signal that the person is
// singing along; the mini player means they are doing something else in the app, so the phone
// sleeps normally. This narrows the issue's "full or mini player" at Michael's word: "That feels
// too broad. I would say only while the full player is up. It should not have to be playing. Just
// being maximized is sufficient."
// (https://github.com/crescendosw/webapp/issues/3608#issuecomment-6483878481). "Loaded" rather
// than "playing" on purpose: the stalls this works around hit when the phone locks between verses
// or between songs, while nothing is playing, so a paused song in the full player still holds.
// The browser drops the lock whenever the page is hidden, so a backgrounded app still lets the
// phone sleep.
export function useKeepScreenAwake(): void {
  const [keepScreenAwake] = useLocalStorage(LocalStorageKey.KeepScreenAwake);
  const [isPlayerMaximized] = useLocalStorage(LocalStorageKey.IsPlayerMaximized);
  const { hymn } = use(SequencerContext);
  const wanted = keepScreenAwake && hymn !== undefined && isPlayerMaximized;

  useEffect(() => {
    if (!wanted) {
      return;
    }
    return holdScreenWakeLock();
  }, [wanted]);
}
